<template>
  <div>

    <div class="card mb-3">
      <div class="card-header">
        <i class="fa fa-bar-chart"></i> {{ $t('dashboard.prospect.title') }}

        <div class="float-right" >
          <a href="#filter" name="filter" v-on:click="expandOrCollapseFilter">
              <span class="fa fa-expand fa-lg" v-if="!filterVisible" ></span>
              <span class="fa fa-compress fa-lg" v-if="filterVisible"></span>
          </a>
        </div>
      </div>
      <div class="card-body" v-if="filterVisible">
        
        <div class="row">

          <div class="form-group col-md-3">
            <label for="memberStatus">{{ $t('member.form.status') }}</label>
            <multiselect v-model="filter.status" track-by="key" label="value"
              :options="memberStatus" :multiple="true" :taggable="false"
              v-bind:placeholder="$t('member.form.status')" 
              v-bind:deselect-label="$t('multiselect.deselect-label')"
              v-bind:select-label="$t('multiselect.selectedLabel')">
            </multiselect>
          </div>

          <div class="form-group col-md-3">
            <label for="sex">{{ $t('member.form.sex') }}</label>
            <multiselect v-model="filter.sex" track-by="item1" label="item2"
              :options="sexes" :multiple="true" :taggable="false"
              v-bind:placeholder="$t('member.form.sex')" 
              v-bind:deselect-label="$t('multiselect.deselect-label')"
              v-bind:select-label="$t('multiselect.selectedLabel')">
            </multiselect>
          </div>
          
          <div class="form-group col-md-6">
            <label for="regionInput">{{ $t('address.form.region') }}</label>
            <multiselect v-model="filter.region" track-by="item1" label="item2"
              :options="regions" :multiple="true" :taggable="false"
              v-bind:placeholder="$t('address.form.region')" 
              v-bind:deselect-label="$t('multiselect.deselect-label')"
              v-bind:select-label="$t('multiselect.selectedLabel')">
            </multiselect>
          </div>
        
        </div>

        <div class="row">

          <div class="form-group col-md-4">
            <label for="educationInput">{{ $t('member.form.education') }}</label>
            <multiselect v-model="filter.education" track-by="item1" label="item2"
              :options="educationLevels" :multiple="true" :taggable="false"
              v-bind:placeholder="$t('member.form.education')" 
              v-bind:deselect-label="$t('multiselect.deselect-label')"
              v-bind:select-label="$t('multiselect.selectedLabel')">
            </multiselect>       
          </div>

        
          <div class="form-group col-md-2"> 
              <label for="memberSince">{{ $t('dashboard.prospect.form.creationFrom') }}</label>
              <moment-date-picker v-model="filter.creationFrom" :required="false"></moment-date-picker>
          </div>
          <div class="form-group col-md-2"> 
              <label for="memberSince">{{ $t('dashboard.prospect.form.creationTo') }}</label>
              <moment-date-picker v-model="filter.creationTo" :required="false"></moment-date-picker>
          </div>

          <div class="form-group col-md-2"> 
              <label for="memberSince">{{ $t('dashboard.prospect.form.memberSinceFrom') }}</label>
              <moment-date-picker v-model="filter.memberSinceFrom" :required="false"></moment-date-picker>
          </div>
          <div class="form-group col-md-2"> 
              <label for="memberSince">{{ $t('dashboard.prospect.form.memberSinceTo') }}</label>
              <moment-date-picker v-model="filter.memberSinceTo" :required="false"></moment-date-picker>
          </div>

        </div>

        <div class="row">

          <div class="form-group col-md-2"> 
              <label for="memberSince">{{ $t('dashboard.prospect.form.actionDateFrom') }}</label>
              <moment-date-picker v-model="filter.actionDateFrom" :required="false"></moment-date-picker>
          </div>
          <div class="form-group col-md-2"> 
              <label for="memberSince">{{ $t('dashboard.prospect.form.actionDateTo') }}</label>
              <moment-date-picker v-model="filter.actionDateTo" :required="false"></moment-date-picker>
          </div>

          <div class="form-group col-md-6">
            <label for="educationInput">{{ $t('member.form.action.type') }}</label>
            <multiselect v-model="filter.actionType" track-by="item1" label="item2"
              :options="actionTypes" :multiple="true" :taggable="false"
              v-bind:placeholder="$t('member.form.action.type')" 
              v-bind:deselect-label="$t('multiselect.deselect-label')"
              v-bind:select-label="$t('multiselect.selectedLabel')">
            </multiselect>       
          </div>

        </div>

      </div>
    </div>

    <div class="row" v-if="data.length == 0">
      
      <div class="col-xl-12 col-sm-6 mb-4" >
        <div :class="'card text-white o-hidden bg-secondary h-100'">
          <div class="card-body">
            <div class="card-body-icon">
              <i class="fa fa-spinner"></i>
            </div>
            <div class="mr-5">{{ $t("loading")}}</div>
          </div>
        </div>
      </div>
    
    </div>

    <div v-if="data.length != 0">
      <div class="row" >
        <div class="col-md-3" >

          <div class="card text-white o-hidden bg-primary">

            <div class="card-body">
              <div class="card-body-icon">
                <i class="fa fa-fw fa-user-circle"></i>
              </div>
              <div class="mr-5">{{ $t("dashboard.prospect.sectionTitle") }}</div>
            </div>
            
            <ul class="list-group list-group-flush text-dark">
              <li class="list-group-item">
                {{ $t("dashboard.prospect.processus") }}
                <span class="pull-right font-weight-bold">{{ processusTotal }}</span>
              </li>
              <li class="list-group-item">
                {{ $t("dashboard.prospect.membre") }}
                <span class="pull-right font-weight-bold">{{ membresTotal }}</span>
              </li>
              <li class="list-group-item">
                {{ $t("dashboard.prospect.prospection") }}
                <span class="pull-right font-weight-bold">{{ prospectsTotal }}</span>
              </li>
              <li class="list-group-item">
                {{ $t("dashboard.prospect.suspendu") }}
                <span class="pull-right font-weight-bold">{{ abandonTotal }}</span>
              </li>
              <li class="list-group-item">
                {{ $t("dashboard.prospect.abandon") }}
                <span class="pull-right font-weight-bold">{{ suspenduTotal }}</span>
              </li>
              <li class="list-group-item">
                {{ $t("dashboard.prospect.successRate") }}
                <span class="pull-right font-weight-bold">{{ pourcentageSucces }} %</span>
              </li>
            </ul>
          </div>

        </div>

        <div class="col-md-9" >

          <div class="row">
            
            <div class="col-md-3"  >

              <div class="card mb-3" v-if="sexData != null">
                <div class="card-header">
                  <i class="fa fa-pie-chart"></i> {{ $t("dashboard.member.sexVisualisation") }} </div>
                  <pie-chart :chart-data="sexData.data" :options="sexData.options"></pie-chart>
              </div>

            </div>

            <div class="col-md-3" >
              <div class="card mb-3"  v-if="educationData != null">
                <div class="card-header">
                  <i class="fa fa-pie-chart"></i> {{ $t("dashboard.member.educationVisualisation") }} </div>
                  <pie-chart :chart-data="educationData.data" :options="educationData.options"></pie-chart>
              </div>

            </div>

            <div class="col-md-6">

              <div class="card mb-3"  v-if="regionData != null">
                <div class="card-header">
                  <i class="fa fa-pie-chart"></i> {{ $t("dashboard.member.regionVisualisation") }}</div>
                  <bar-chart :chart-data="regionData.data" :options="regionData.options"></bar-chart>
              </div>
          
            </div>

          </div>

        </div>

      </div>
    </div>

  </div>
</template>

<script>
import ServiceFactory from '../../shared/service-clients/serviceClientFactory'
import {
  MemberServiceClient,
  ProjectServiceClient,
  InvestmentServiceClient,
  ExitServiceClient,
  AddressServiceClient,
  PersonServiceClient,
  RoleServiceClient,
} from '../../shared/service-clients/service-clients'

import DashboardMixin from '../../shared/Mixin/DashboardMixin'

export default {
  name: 'ProspectDashboard',
  mixins: [DashboardMixin],
  data() {
    return {
      data: [],
      regions: [],
      sexes: [],
      memberStatus: [],
      educationLevels: [],
      actionTypes: [],
      filter: {
        sex: [],
        status: [],
        region: [],
        education: [],
        actionType: [],
        creationFrom: null,
        creationTo: null,
        actionDateFrom: null,
        actionDateTo: null,
        memberSinceFrom: null,
        memberSinceTo: null,
      },
    }
  },
  computed: {
    processusTotal: function() {
      return this.filteredData.length
    },
    membresTotal: function() {
      return _.chain(this.filteredData)
        .filter(f => f.type != 2)
        .value().length
    },
    prospectsTotal: function() {
      return _.chain(this.filteredData)
        .filter(f => f.type == 2 && f.status == 2)
        .value().length
    },
    abandonTotal: function() {
      return _.chain(this.filteredData)
        .filter(f => f.type == 2 && f.status == 6)
        .value().length
    },
    suspenduTotal: function() {
      return _.chain(this.filteredData)
        .filter(f => f.type == 2 && f.status == 5)
        .value().length
    },
    pourcentageSucces: function() {
      return this.membresTotal / this.processusTotal * 100
    },
    prospectData: function() {
      return _.filter(this.filteredData, f => f.type == 2)
    },
    sexData: function() {
      return this.getChartData('sexText', this.prospectData)
    },
    regionData: function() {
      return this.getChartData('regionText', this.prospectData)
    },
    educationData: function() {
      return this.getChartData('educationText', this.prospectData)
    },
    filteredData: function() {
      let filtered = this.data

      filtered = this.filterPropertyByList(filtered, this.filter.sex, 'sex')
      filtered = this.filterPropertyByList(filtered, this.filter.status, 'status')
      filtered = this.filterPropertyByList(filtered, this.filter.region, 'region')
      filtered = this.filterPropertyByList(filtered, this.filter.education, 'education')

      if (this.filter.actionType.length != 0) {
        filtered = _.filter(filtered, x => _.some(x.actions, s => _.find(this.filter.actionType, f => f.item1 == s.type)))
      }

      if (this.filter.creationFrom != null) {
        filtered = _.filter(filtered, x => x.creation != null && moment(x.creation).isAfter(this.filter.creationFrom))
      }
      if (this.filter.creationTo != null) {
        filtered = _.filter(filtered, x => x.creation != null && moment(x.creation).isBefore(this.filter.creationTo))
      }

      if (this.filter.memberSinceFrom != null) {
        filtered = _.filter(filtered, x => x.memberSince != null && moment(x.memberSince).isAfter(this.filter.memberSinceFrom))
      }
      if (this.filter.memberSinceTo != null) {
        filtered = _.filter(filtered, x => x.memberSince != null && moment(x.memberSince).isBefore(this.filter.memberSinceTo))
      }

      if (this.filter.actionDateFrom != null) {
        filtered = _.filter(filtered, x => _.some(x.actions, s => moment(s.timestamp).isAfter(this.filter.actionDateFrom)))
      }
      if (this.filter.actionDateTo != null) {
        filtered = _.filter(filtered, x => _.some(x.actions, s => moment(x.timestamp).isBefore(this.filter.actionDateTo)))
      }

      return filtered
    },
  },
  methods: {
    fetchData: function() {
      let self = this
      // Workaround for the first time hit bug
      // TODO : Essayer de comprends qqs se passe...
      let pingService = ServiceFactory.create(RoleServiceClient)
      pingService.getAll(0, 1).then(rest => {
        let memberService = ServiceFactory.create(MemberServiceClient)
        let addressService = ServiceFactory.create(AddressServiceClient)
        let personService = ServiceFactory.create(PersonServiceClient)

        self.getMemberData(memberService)
        self.getFilterData(memberService, addressService, personService)
      })
    },
    getFilterData: function(memberService, addressService, personService) {
      let self = this

      addressService.getRegions().then(res => {
        self.regions = res
      })
      personService.getSexes().then(res => {
        self.sexes = res
      })
      memberService.getStatus().then(res => {
        self.memberStatus = res
      })
      personService.getEducations().then(res => {
        self.educationLevels = res
      })
      memberService.getActionTypes().then(res => {
        self.actionTypes = res
      })
    },
    getMemberData: function(service) {
      let self = this
      service
        .getDashboardProspectData()
        .then(res => {
          self.data = res
          self.filterVisible = true
        })
        .catch(err => {
          console.log(err)
        })
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Prospect.vue